import { useCallback, useEffect, useRef, useState } from 'preact/hooks'
import { OmneoClient } from '../classes/client'
import { OmneoClientWrapper } from '../classes/clientWrapper'

export function useOmneoClient(reloadIfNotLoggedIn) {
  /**
   * @type {[OmneoClientWrapper, Dispatch<StateUpdater<OmneoClientWrapper>>]}
   */
  const [client, setClient] = useState()
  const [error, setError] = useState(null)
  const [attempt, setAttempt] = useState(0)

  /**
   * Which attempt has already been started. Without it, setting error state re-renders and the
   * effect runs again, so a failing init retries forever.
   */
  const startedRef = useRef(-1)

  const retry = useCallback(() => {
    setError(null)
    setAttempt((count) => count + 1)
  }, [])

  useEffect(() => {
    // eslint-disable-next-line camelcase
    if (reloadIfNotLoggedIn && !global_booking.customer.length) {
      window.location.href = '/#account'
      return
    }
    if (client || startedRef.current === attempt) return
    startedRef.current = attempt

    let cancelled = false
    OmneoClient.init()
      .then((initialised) => {
        if (cancelled) return
        setClient(new OmneoClientWrapper(initialised))
      })
      .catch((initError) => {
        if (cancelled) return
        console.error('Failed to initialise the Omneo client:', initError)
        setError(initError)
      })

    return () => {
      cancelled = true
    }
  }, [client, attempt, reloadIfNotLoggedIn])

  return { client, error, retry }
}
